import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../molecules/FlexRow'
import SydButton from '../../../../commonDesign/Button'
import { orionSystem } from '../../../../../api/integrations'

function JobActions ({ job }) {
  const { mutateAsync: start, isLoading: starting } = orionSystem.useStartOrionSystemSync()

  const handleStart = useCallback(async (syncStrategy) => {
    return await start({
      objects: [job.jobKey],
      syncStrategy
    })
  }, [job, start])

  return (
    <FlexRow>
      <SydButton size='xs' icon='sync' variant='primary' processing={starting} onClick={() => handleStart('differential')}>Differential</SydButton>
      <SydButton size='xs' icon='sync' variant='primary' processing={starting} onClick={() => handleStart('full')}>Full</SydButton>
    </FlexRow>
  )
}

JobActions.propTypes = {
  job: PropTypes.shape({
    jobKey: PropTypes.string
  })
}

export default JobActions
